// extracted by mini-css-extract-plugin
export var container = "PostCard-module--container--63cad";
export var excerpt = "PostCard-module--excerpt--41606";
export var meta = "PostCard-module--meta--e861c";
export var metaItem = "PostCard-module--metaItem--a7e5b";
export var title = "PostCard-module--title--bfd44";